(function () {
    function initCustomerStory(root) {
      if (!root || root.dataset.initialized === "true") return;

      root.dataset.initialized = "true";
      root.classList.add("is-enhanced");


    var stage = root.querySelector(
      ".fabric-carousel__stage"
    );

    var previousButton = root.querySelector(
      ".fabric-carousel__arrow--previous"
    );

    var nextButton = root.querySelector(
      ".fabric-carousel__arrow--next"
    );

    var carousel = root.querySelector(
      ".fabric-carousel__carousel"
    );

    var lightbox = root.querySelector(
      ".fabric-carousel__lightbox"
    );

    var lightboxImage = root.querySelector(
      ".fabric-carousel__lightbox-image"
    );

    var lightboxClose = root.querySelector(
      ".fabric-carousel__lightbox-close"
    );

    var lightboxPrevious = root.querySelector(
      ".fabric-carousel__lightbox-nav--previous"
    );

    var lightboxNext = root.querySelector(
      ".fabric-carousel__lightbox-nav--next"
    );

    var cards = Array.prototype.slice.call(
      root.querySelectorAll(".fabric-carousel__card")
    );

    var images = cards.map(function (card) {
      var image = card.querySelector("img");
      return image ? image.currentSrc || image.src : "";
    });

    var activeIndex = Math.min(3, Math.max(0, cards.length - 1));
    var touchStartX = 0;
    var touchStartY = 0;
    var touchActive = false;
    var suppressClickUntil = 0;
    var navigationLocked = false;
    var lightboxIndex = 0;
    var lightboxTouchStartX = 0;
    var lightboxTouchStartY = 0;
    var lightboxTouchActive = false;

    var positionClasses = [
      "pos-n3",
      "pos-n2",
      "pos-n1",
      "pos-0",
      "pos-p1",
      "pos-p2",
      "pos-p3",
      "is-hidden-left",
      "is-hidden-right"
    ];


    function loadCard(card, highPriority) {
      var image = card.querySelector("img");

      if (!image) return;

      if (highPriority) {
        image.loading = "eager";
        image.fetchPriority = "high";
      }

      image.dataset.loaded = "true";
    }

    function modulo(value, length) {
      return ((value % length) + length) % length;
    }

    function getDistance(index) {
      var distance = index - activeIndex;
      var half = images.length / 2;

      if (distance > half) {
        distance -= images.length;
      }

      if (distance < -half) {
        distance += images.length;
      }

      return distance;
    }

    function getPositionClass(distance) {
      if (distance === -3) return "pos-n3";
      if (distance === -2) return "pos-n2";
      if (distance === -1) return "pos-n1";
      if (distance === 0) return "pos-0";
      if (distance === 1) return "pos-p1";
      if (distance === 2) return "pos-p2";
      if (distance === 3) return "pos-p3";

      return distance < 0
        ? "is-hidden-left"
        : "is-hidden-right";
    }

    function updateCards() {
      cards.forEach(function (card, index) {
        positionClasses.forEach(function (className) {
          card.classList.remove(className);
        });

        var distance = getDistance(index);
        var isVisible = Math.abs(distance) <= 3;

        card.classList.add(
          getPositionClass(distance)
        );

        card.classList.toggle(
          "is-active",
          index === activeIndex
        );

        if (isVisible) {
          loadCard(
            card,
            index === activeIndex
          );
        }

        if (index === activeIndex) {
          card.setAttribute(
            "aria-current",
            "true"
          );

          card.setAttribute(
            "tabindex",
            "0"
          );
        } else if (isVisible) {
          card.removeAttribute(
            "aria-current"
          );

          card.setAttribute(
            "tabindex",
            "0"
          );
        } else {
          card.removeAttribute(
            "aria-current"
          );

          card.setAttribute(
            "tabindex",
            "-1"
          );
        }
      });
    }

    function setActive(index) {
      if (navigationLocked) return;

      activeIndex = modulo(
        index,
        images.length
      );

      updateCards();

      navigationLocked = true;

      window.setTimeout(function () {
        navigationLocked = false;
      }, 280);
    }

    function renderLightboxImage(index) {
      if (!lightboxImage || !cards.length) return;

      lightboxIndex = modulo(index, cards.length);

      var selectedCard = cards[lightboxIndex];
      var selectedImage = selectedCard
        ? selectedCard.querySelector("img")
        : null;

      if (!selectedImage) return;

      loadCard(selectedCard, true);

      lightboxImage.src = selectedImage.currentSrc || selectedImage.src;
      lightboxImage.srcset = selectedImage.srcset || "";
      lightboxImage.sizes = "92vw";
      lightboxImage.alt = selectedImage.alt || "Enlarged customer photo";
    }

    function openLightbox(index) {
      if (!lightbox || !lightboxImage) return;

      renderLightboxImage(index);

      lightbox.classList.add("is-open");
      lightbox.setAttribute("aria-hidden", "false");
      root.classList.add("lightbox-open");
      document.body.classList.add("fabric-carousel-lightbox-open");

      window.setTimeout(function () {
        if (lightboxClose) lightboxClose.focus();
      }, 30);
    }

    function changeLightboxImage(direction) {
      if (!lightbox || !lightbox.classList.contains("is-open")) return;
      renderLightboxImage(lightboxIndex + direction);
    }

    function closeLightbox() {
      if (!lightbox || !lightbox.classList.contains("is-open")) return;

      lightbox.classList.remove("is-open");
      lightbox.setAttribute("aria-hidden", "true");
      root.classList.remove("lightbox-open");
      document.body.classList.remove("fabric-carousel-lightbox-open");

      var activeCard = cards[activeIndex];
      if (activeCard) activeCard.focus();
    }

    function bindCardEvents() {
      cards.forEach(function (card, index) {
        card.addEventListener(
          "click",
          function (event) {
            if (
              Date.now() < suppressClickUntil
            ) {
              event.preventDefault();
              return;
            }

            if (index !== activeIndex) {
              event.preventDefault();
              setActive(index);
              return;
            }

            event.preventDefault();
            openLightbox(index);
          }
        );

        card.addEventListener(
          "keydown",
          function (event) {
            if (event.key === "ArrowLeft") {
              event.preventDefault();

              setActive(
                activeIndex - 1
              );
            }

            if (event.key === "ArrowRight") {
              event.preventDefault();

              setActive(
                activeIndex + 1
              );
            }
          }
        );
      });
    }

    previousButton.addEventListener(
      "click",
      function () {
        setActive(activeIndex - 1);
      }
    );

    nextButton.addEventListener(
      "click",
      function () {
        setActive(activeIndex + 1);
      }
    );

    if (lightbox && lightboxClose) {
      lightboxClose.addEventListener(
        "click",
        closeLightbox
      );

      if (lightboxPrevious) {
        lightboxPrevious.addEventListener(
          "click",
          function (event) {
            event.stopPropagation();
            changeLightboxImage(-1);
          }
        );
      }

      if (lightboxNext) {
        lightboxNext.addEventListener(
          "click",
          function (event) {
            event.stopPropagation();
            changeLightboxImage(1);
          }
        );
      }

      lightbox.addEventListener(
        "click",
        function (event) {
          if (
            event.target === lightbox ||
            event.target.classList.contains(
              "fabric-carousel__lightbox-inner"
            )
          ) {
            closeLightbox();
          }
        }
      );

      lightbox.addEventListener(
        "touchstart",
        function (event) {
          if (
            !event.touches ||
            !event.touches.length
          ) {
            return;
          }

          lightboxTouchStartX =
            event.touches[0].clientX;

          lightboxTouchStartY =
            event.touches[0].clientY;

          lightboxTouchActive = true;
        },
        { passive: true }
      );

      lightbox.addEventListener(
        "touchcancel",
        function () {
          lightboxTouchActive = false;
        },
        { passive: true }
      );

      lightbox.addEventListener(
        "touchend",
        function (event) {
          if (
            !lightboxTouchActive ||
            !event.changedTouches ||
            !event.changedTouches.length
          ) {
            return;
          }

          var changeX =
            event.changedTouches[0].clientX -
            lightboxTouchStartX;

          var changeY =
            event.changedTouches[0].clientY -
            lightboxTouchStartY;

          lightboxTouchActive = false;

          if (
            Math.abs(changeX) < 45 ||
            Math.abs(changeX) <= Math.abs(changeY)
          ) {
            return;
          }

          if (changeX < 0) {
            changeLightboxImage(1);
          } else {
            changeLightboxImage(-1);
          }
        },
        { passive: true }
      );

      document.addEventListener(
        "keydown",
        function (event) {
          if (!lightbox.classList.contains("is-open")) {
            return;
          }

          if (event.key === "Escape") {
            closeLightbox();
            return;
          }

          if (event.key === "ArrowLeft") {
            event.preventDefault();
            changeLightboxImage(-1);
            return;
          }

          if (event.key === "ArrowRight") {
            event.preventDefault();
            changeLightboxImage(1);
          }
        }
      );
    }

    carousel.addEventListener(
      "touchstart",
      function (event) {
        if (
          !event.touches ||
          !event.touches.length
        ) {
          return;
        }

        touchStartX =
          event.touches[0].clientX;

        touchStartY =
          event.touches[0].clientY;

        touchActive = true;
      },
      { passive: true }
    );

    carousel.addEventListener(
      "touchcancel",
      function () {
        touchActive = false;
      },
      { passive: true }
    );

    carousel.addEventListener(
      "touchend",
      function (event) {
        if (
          !touchActive ||
          !event.changedTouches ||
          !event.changedTouches.length
        ) {
          return;
        }

        var changeX =
          event.changedTouches[0].clientX -
          touchStartX;

        var changeY =
          event.changedTouches[0].clientY -
          touchStartY;

        touchActive = false;

        if (
          Math.abs(changeX) < 42 ||
          Math.abs(changeX) <= Math.abs(changeY)
        ) {
          return;
        }

        suppressClickUntil =
          Date.now() + 500;

        if (changeX < 0) {
          setActive(activeIndex + 1);
        } else {
          setActive(activeIndex - 1);
        }
      },
      { passive: true }
    );

    var revealItems =
      root.querySelectorAll(
        ".fabric-reveal"
      );

    var reducedMotion =
      window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;

    if (
      reducedMotion ||
      !("IntersectionObserver" in window)
    ) {
      revealItems.forEach(function (item) {
        item.classList.add("is-visible");
      });
    } else {
      var observer =
        new IntersectionObserver(
          function (entries) {
            entries.forEach(
              function (entry) {
                if (!entry.isIntersecting) {
                  return;
                }

                var item = entry.target;

                var delay = Number(
                  item.dataset.delay || 0
                );

                item.style.transitionDelay =
                  delay + "ms";

                item.classList.add(
                  "is-visible"
                );

                observer.unobserve(item);
              }
            );
          },
          {
            threshold: 0.15,
            rootMargin:
              "0px 0px -60px 0px"
          }
        );

      revealItems.forEach(function (item) {
        observer.observe(item);
      });
    }

    bindCardEvents();
    updateCards();
    }

    function initAllCustomerStories(scope) {
      var context = scope || document;
      var roots = context.querySelectorAll
        ? context.querySelectorAll("[data-dmt-customer-story]")
        : [];

      roots.forEach(function (root) {
        initCustomerStory(root);
      });
    }

    initAllCustomerStories(document);

    document.addEventListener("shopify:section:load", function (event) {
      initAllCustomerStories(event.target);
    });
  })();